import { TranslationKeyWithPrefix } from '../../../shared/utils/translate';

export const CHOOSE_WISELY_COPY_KEY = 'steps.profile_setup.choose_wisely' satisfies TranslationKeyWithPrefix;

export const USERNAME_MAX_LENGTH = 15;
